import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CameraRearIcon(props: IconProps) {
    return <Icon {...props} iconKey={"camera_rear"}/>
}
